import Vue from 'vue';
import $ from 'jquery';

Vue.directive('tooltip', function(el, binding){
    $(el).attr('data-toggle', 'tooltip')
        .attr('title', binding.value)
        .attr('data-placement', binding.arg)
        .attr('trigger', 'hover').tooltip();
});



// WEBPACK FOOTER //
// ./FrontEnd/diretivas/tooltip.js